import { render, staticRenderFns } from "./password.vue?vue&type=template&id=aa3d2cb0&scoped=true"
import script from "./password.vue?vue&type=script&lang=ts"
export * from "./password.vue?vue&type=script&lang=ts"
import style0 from "./password.vue?vue&type=style&index=0&id=aa3d2cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3d2cb0",
  null
  
)

export default component.exports